import breakpoints from './breakpoints';
import sizes from './sizes';
import styles from './styles';
import shadows from './shadows';
import colors from './colors';

export const foundations = {
  breakpoints,
  colors,
  sizes,
  styles,
  shadows,
};
